// API Configuration Constants
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000',
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
  STORAGE_URL: process.env.REACT_APP_STORAGE_URL || 'http://localhost:8000/storage',
} as const;

// Frontend Configuration
export const FRONTEND_CONFIG = {
  BASE_URL: process.env.REACT_APP_FRONTEND_URL || 'http://localhost:3000',
} as const;

// AI Service Configuration
export const AI_SERVICE_CONFIG = {
  BASE_URL: process.env.REACT_APP_AI_SERVICE_URL || 'http://localhost:8001',
} as const;

// Development Configuration
export const DEV_CONFIG = {
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
} as const;

// Export all configs
export const CONFIG = {
  API: API_CONFIG,
  FRONTEND: FRONTEND_CONFIG,
  AI_SERVICE: AI_SERVICE_CONFIG,
  DEV: DEV_CONFIG,
} as const;

export default CONFIG; 